module.exports = __webpack_public_path__ + "img/0S6A0081.76e83678.jpg";